import { FC } from 'react';

import { Grid, Theme, Typography, useMediaQuery } from '@mui/material';

import Form from './Form';

interface Props {
  isForgotPassword?: boolean | null;
}

const ForgotAndPasswordReset: FC<Props> = ({ isForgotPassword }) => {
  const isSmallScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm'),
  );
  return (
    <Grid
      container
      spacing={2}
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '70vh',
        padding: '2.5rem 0.5rem',
      }}
    >
      <Grid>
        <Typography variant="h5" sx={{ textAlign: 'center' }}>
          {isForgotPassword
            ? 'Need to reset your password?'
            : 'Reset My Password'}
        </Typography>
      </Grid>
      <Grid>
        <Typography variant="body1" sx={{ textAlign: 'center' }}>
          {isForgotPassword &&
            `No sweat. Enter your account email address here, and we’ll send you instructions `}
          {!isSmallScreen && isForgotPassword && <br />}
          {isForgotPassword && 'to reset your password.'}
        </Typography>
      </Grid>
      <Grid>
        <Form isForgotPassword={isForgotPassword} />
      </Grid>
    </Grid>
  );
};

export default ForgotAndPasswordReset;
